module.exports = __webpack_public_path__ + "static/media/face4.d61ed34d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/face4.svg
// module id = 974
// module chunks = 0